// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Cn from "re-classnames/src/Cn.bs.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Utils from "./utils.bs.js";
import * as React from "react";
import * as Belt_List from "bs-platform/lib/es6/belt_List.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Minesweeper from "./minesweeper.bs.js";

function Ui$Double_click(Props) {
  var onSingleClick = Props.onClick;
  var onDoubleClick = Props.onDoubleClick;
  var children = Props.children;
  var lastClickAtRef = React.useRef(0.0);
  var timeoutIdRef = React.useRef(undefined);
  var onClick = function (evt) {
    evt.preventDefault();
    var now = Date.now();
    var lastClickAt = lastClickAtRef.current;
    var isDoubleClick = lastClickAt + 200.0 > now;
    lastClickAtRef.current = now;
    var id = timeoutIdRef.current;
    if (id !== undefined) {
      clearTimeout(Caml_option.valFromOption(id));
    }
    if (isDoubleClick) {
      return Curry._1(onDoubleClick, evt);
    }
    evt.persist();
    var timeoutId = setTimeout((function (param) {
            return Curry._1(onSingleClick, evt);
          }), 200);
    timeoutIdRef.current = Caml_option.some(timeoutId);
    
  };
  return React.createElement("div", {
              onClick: onClick
            }, children);
}

var Double_click = {
  thresholdMs: 200.0,
  make: Ui$Double_click
};

function Ui$Field(Props) {
  var mines = Props.mines;
  var field = Props.field;
  var fieldState = Props.fieldState;
  var onClick = Props.onClick;
  var onDoubleClick = Props.onDoubleClick;
  var display;
  switch (fieldState.visibility) {
    case /* Hidden */0 :
        display = /* Hidden */0;
        break;
    case /* Revealed */1 :
        display = fieldState.contents ? /* Safe */({
              mines: mines
            }) : /* Exploded */2;
        break;
    case /* Marked */2 :
        display = /* Marked */1;
        break;
    
  }
  var buttonContent;
  if (typeof display === "number") {
    switch (display) {
      case /* Hidden */0 :
          buttonContent = null;
          break;
      case /* Marked */1 :
          buttonContent = "🚩";
          break;
      case /* Exploded */2 :
          buttonContent = "💥";
          break;
      
    }
  } else {
    buttonContent = display.mines;
  }
  var baseClassName = "game__board-field";
  var revealedClassName = typeof display === "number" ? (
      display >= 2 ? baseClassName + "--revealed" : ""
    ) : baseClassName + "--revealed";
  var contentClassName = typeof display === "number" ? (
      display >= 2 ? baseClassName + "--exploded" : ""
    ) : baseClassName + "--" + String(display.mines);
  var className = Cn.make({
        hd: baseClassName,
        tl: {
          hd: revealedClassName,
          tl: {
            hd: contentClassName,
            tl: /* [] */0
          }
        }
      });
  var onClick$1 = function (_evt) {
    return Curry._1(onClick, field);
  };
  var onDoubleClick$1 = function (_event) {
    return Curry._1(onDoubleClick, field);
  };
  return React.createElement(Ui$Double_click, {
              onClick: onClick$1,
              onDoubleClick: onDoubleClick$1,
              children: React.createElement("div", {
                    className: className
                  }, React.createElement("button", {
                        type: "button"
                      }, buttonContent))
            });
}

function arePropsEqual(oldProps, newProps) {
  var oldState = oldProps.fieldState;
  var newState = newProps.fieldState;
  return oldState === newState;
}

var make = React.memo(Ui$Field, arePropsEqual);

var Field = {
  arePropsEqual: arePropsEqual,
  make: make
};

function reducer(state, action) {
  return Minesweeper.update(action, state);
}

function Ui$Game(Props) {
  var width = Props.width;
  var height = Props.height;
  var mines = Props.mines;
  var match = React.useReducer(reducer, undefined, (function (param) {
          return Minesweeper.initializeState(width, height, mines);
        }));
  var send = match[1];
  var state = match[0];
  var width$1 = Minesweeper.gameWidthSelector(state);
  var height$1 = Minesweeper.gameHeightSelector(state);
  var xs = Utils.range(0, width$1);
  var ys = Utils.range(0, height$1);
  var gameStatus = Minesweeper.gameStatusSelector(state);
  var rows = Belt_List.toArray(Belt_List.map(ys, (function (y) {
              return React.createElement("div", {
                          key: String(y),
                          className: "game__board-row"
                        }, Belt_List.toArray(Belt_List.map(xs, (function (x) {
                                    var field = {
                                      x: x,
                                      y: y
                                    };
                                    var fieldState = Minesweeper.fieldStateSelector(state, field);
                                    var displayedFieldState = gameStatus !== 1 || fieldState.contents ? fieldState : ({
                                          contents: /* Mine */0,
                                          visibility: /* Marked */2
                                        });
                                    var onClick = function (field) {
                                      return Curry._1(send, {
                                                  TAG: /* ToggleMarker */2,
                                                  _0: field
                                                });
                                    };
                                    var onDoubleClick = function (field) {
                                      return Curry._1(send, {
                                                  TAG: /* Reveal */1,
                                                  _0: field
                                                });
                                    };
                                    var mines = Minesweeper.adjacentMinesCountSelector(state, field);
                                    return React.createElement(make, {
                                                mines: mines,
                                                field: field,
                                                fieldState: displayedFieldState,
                                                onClick: onClick,
                                                onDoubleClick: onDoubleClick,
                                                key: String(x)
                                              });
                                  }))));
            })));
  var buttonContents;
  switch (gameStatus) {
    case /* Playing */0 :
        buttonContents = "🙂";
        break;
    case /* Won */1 :
        buttonContents = "😎";
        break;
    case /* Lost */2 :
        buttonContents = "😵";
        break;
    
  }
  var startButtonClick = function (_evt) {
    return Curry._1(send, {
                TAG: /* Init */0,
                _0: Minesweeper.initializeState(width$1, height$1, mines)
              });
  };
  var remainingMines = Minesweeper.remainingMinesCountSelector(state);
  return React.createElement("section", {
              className: "game__wrapper"
            }, React.createElement("div", {
                  className: "game"
                }, React.createElement("div", {
                      className: "game__header"
                    }, React.createElement("div", {
                          className: "game__remaining-mines"
                        }, remainingMines), React.createElement("button", {
                          className: "game__start-button",
                          type: "button",
                          onClick: startButtonClick
                        }, buttonContents)), React.createElement("div", {
                      className: "game__board"
                    }, rows)), React.createElement("p", {
                  className: "instructions"
                }, "double-click to reveal a field / click to mark a field"));
}

var Game = {
  reducer: reducer,
  make: Ui$Game
};

var logo = (require('./logo.svg'));

function reducer$1(_state, action) {
  return action._0;
}

function Ui$App(Props) {
  var message = Props.message;
  var match = React.useReducer(reducer$1, undefined);
  var send = match[1];
  var state = match[0];
  var contents;
  if (state !== undefined) {
    var match$1;
    switch (state) {
      case /* Easy */0 :
          match$1 = [
            9,
            9,
            10
          ];
          break;
      case /* Normal */1 :
          match$1 = [
            16,
            16,
            40
          ];
          break;
      case /* Hard */2 :
          match$1 = [
            30,
            16,
            99
          ];
          break;
      
    }
    contents = React.createElement(Ui$Game, {
          width: match$1[0],
          height: match$1[1],
          mines: match$1[2]
        });
  } else {
    contents = React.createElement("div", {
          className: "difficulties__wrapper"
        }, React.createElement("h3", undefined, "Choose difficulty"), React.createElement("div", {
              className: "difficulties"
            }, React.createElement("button", {
                  className: "difficulty",
                  title: "Easy",
                  type: "button",
                  onClick: (function (param) {
                      return Curry._1(send, /* ChooseDifficulty */{
                                  _0: /* Easy */0
                                });
                    })
                }, "😌"), React.createElement("button", {
                  className: "difficulty",
                  title: "Normal",
                  type: "button",
                  onClick: (function (param) {
                      return Curry._1(send, /* ChooseDifficulty */{
                                  _0: /* Normal */1
                                });
                    })
                }, "😐"), React.createElement("button", {
                  className: "difficulty",
                  title: "Hard",
                  type: "button",
                  onClick: (function (param) {
                      return Curry._1(send, /* ChooseDifficulty */{
                                  _0: /* Hard */2
                                });
                    })
                }, "😱")));
  }
  return React.createElement("div", {
              className: "app"
            }, React.createElement("div", {
                  className: "app__header"
                }, React.createElement("a", {
                      href: ""
                    }, React.createElement("img", {
                          className: "app__logo",
                          alt: "logo",
                          src: logo
                        })), React.createElement("h2", undefined, message), React.createElement("p", {
                      className: "app__credits"
                    }, "by ", React.createElement("a", {
                          href: "http://pewniak747.info",
                          target: "_blank"
                        }, "Tomasz Pewiński"), " · ", React.createElement("a", {
                          href: "https://github.com/pewniak747/minesweeper-reasonml",
                          target: "_blank"
                        }, "source"))), React.createElement("div", {
                  className: "app__intro"
                }, contents));
}

var App = {
  logo: logo,
  reducer: reducer$1,
  make: Ui$App
};

export {
  Double_click ,
  Field ,
  Game ,
  App ,
  
}
/* make Not a pure module */
